const PAGE_SIZE_OPTIONS = [10, 15, 20, 50, 100];

const DEFAULT_PAGE_NUMBER = 1;

const DEFAULT_PAGE_SIZE = 10;

const DEFAULT_SIZE_CHANGER = {
  showSizeChanger: true,
  pageSizeOptions: PAGE_SIZE_OPTIONS.map((size) => String(size)),
  locale: {
    items_per_page: 'RecordsPerPage',
  },
};

export default {
  PAGE_SIZE_OPTIONS,
  DEFAULT_SIZE_CHANGER,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
};

// URL parameter keys for relative time expressions used across Discover screens
export const RELATIVE_FROM_PARAM = 'rf';
export const RELATIVE_TO_PARAM = 'rt';

// URL parameter keys identifying the log opened in the Discover details panel,
// so a single log can be linked to, shared, and opened in a new tab
export const EVENT_ID_PARAM = 'eventId';
export const EVENT_DATE_PARAM = 'eventDate';
// Unix seconds of that log — anchor for the Surrounding tab; without it a
// shared link opens the details but cannot query surrounding events
export const EVENT_TS_PARAM = 'eventTs';
